import React, { useState } from "react";

import CountryInput from "./CountryInput";
import StateInput from "./StateInput";

const DonationError = ({
    donationDetails,
    fieldName, 
}) => {
    if(!donationDetails?.errors || !donationDetails.errors[fieldName]) {
        return '';
    }

    return (
        <span class="error">{donationDetails.errors[fieldName]}</span>
    )
}

// DonationOptions component; displays the donation page in the ticket checkout process
const DonationOptions = (props) => {
    const {acfData, donationAmount, setDonationAmount, donationDetails, setDonationDetails} = props;
    const [isCustom, setIsCustom] = useState(false);

    function updateDonationDetails(newDonationDetails, newDonationAmount) {
        const newErrors = {};

        if(newDonationAmount && newDonationAmount !== '0.00') {
            if(newDonationDetails.donorRecognitionType === 'organization' && !newDonationDetails.organizationName?.trim()) {
                newErrors['organizationName'] = 'This field is required.';
            }

            if(newDonationDetails.hasBeneficiary) {
                if(!newDonationDetails.dedicationFirstName?.trim()) {
                    newErrors['dedicationFirstName'] = 'This field is required.';
                }

                if(!newDonationDetails.dedicationLastName?.trim()) {
                    newErrors['dedicationLastName'] = 'This field is required.';
                }
            }
        }

        newDonationDetails.errors = newErrors;
        newDonationDetails.valid = !Object.keys(newErrors).length;

        setDonationDetails(newDonationDetails);
    }

    function handleDonationAmount(e) {
        setIsCustom(false);
        if (e.target.value === donationAmount) {
            e.target.checked = false;
            setDonationAmount('0.00');
            updateDonationDetails(donationDetails, '0.00')
        } else {
            setDonationAmount(e.target.value);
            updateDonationDetails(donationDetails, e.target.value)
        }
    }

    function handleCustomToggle(e) {
        setIsCustom(!isCustom);
        setDonationAmount('0.00');
        updateDonationDetails(donationDetails, '0.00');
    }

    function handleCustomInput(e) {
        if (e.target.value.length > 0) {
            const newDonationAmount = parseFloat(e.target.value).toFixed(2);

            setDonationAmount(newDonationAmount);
            updateDonationDetails(donationDetails, newDonationAmount)
        } else {
            setDonationAmount('0.00');
            updateDonationDetails(donationDetails, '0.00');
        }
    }

    function handleDonationDetails(e) {
        const newDonationDetails = {
            ...donationDetails, 
            [e.target.name]: e.target.type === "checkbox" 
                ? e.target.checked 
                : e.target.value 
        };

        updateDonationDetails(newDonationDetails, donationAmount);
    }

    return (
        <>
            <div className="donation-content">
                <article>
                    {acfData && <div dangerouslySetInnerHTML={{__html: acfData.acf.donate_content}}></div>}
                </article>
                {acfData && <img src={acfData.acf.donate_image.url} alt={acfData.acf.donate_image.caption} />}
            </div>
            <form className="donation-form">
                {acfData && acfData.acf.donation_amounts.map(option => {return (
                    <div className="fieldgroup fieldgroup--radio">
                        <input type="radio" id={option.amount} value={`${option.amount}.00`} name="donation-amount" onClick={(e) => handleDonationAmount(e)}/>
                        <label for={option.amount}>${option.amount}.00</label>
                        <span>{option.description}</span>
                    </div>
                )})}
                <div className="fieldgroup fieldgroup--radio">
                    <input
                        type="radio" id="custom" value="custom" name="donation-amount"
                        checked={isCustom}
                        onClick={(e) => handleCustomToggle(e)}
                    />
                    <label htmlFor="custom">Give a custom amount</label>
                </div>
                {isCustom && <div className="fieldgroup">
                    <input
                        type="number" id="custom-amount" name="custom-amount" min="1" step="1" placeholder="$"
                        onChange={(e) => handleCustomInput(e)}
                    />
                </div>}
                {parseFloat(donationAmount) > 0 && <>
                    <h5>Add a recognition (optional)</h5>
                    <div className="fieldgroup fieldgroup--checkbox">
                        <input type="radio" id="self" value="self" name="donorRecognitionType" onClick={(e) => handleDonationDetails(e)} checked={donationDetails.donorRecognitionType === 'self'} />
                        <label htmlFor="self">In my name (Enter your name during payment)</label>
                    </div>
                    <div className="fieldgroup fieldgroup--checkbox">
                        <input type="radio" id="anonymous" value="anonymous" name="donorRecognitionType" onClick={(e) => handleDonationDetails(e)} checked={donationDetails.donorRecognitionType === 'anonymous'}/>
                        <label htmlFor="anonymous">Anonymous</label>
                    </div>
                    <div className="fieldgroup fieldgroup--checkbox">
                        <input type="radio" id="organization" value="organization" name="donorRecognitionType" onClick={(e) => handleDonationDetails(e)} checked={donationDetails.donorRecognitionType === 'organization'}/>
                        <label htmlFor="organization">On behalf of an organization</label>
                    </div>
                    {donationDetails.donorRecognitionType === "organization" && <div className="fieldgroup">
                        <label htmlFor="organizationName" className="sr-only">Organization Name</label>
                        <input id="organization-name" type="text" name="organizationName" placeholder="Organization Name" value={donationDetails.organizationName} onChange={(e) => handleDonationDetails(e)} required />
                        <DonationError donationDetails={donationDetails} fieldName="organizationName" />
                    </div>}
                    <div className="fieldgroup fieldgroup--checkbox">
                        <input type="checkbox" id="has-beneficiary" value="self" name="hasBeneficiary" onClick={(e) => handleDonationDetails(e)} checked={donationDetails.hasBeneficiary}/>
                        <label htmlFor="has-beneficiary">Make this donation in honor of someone</label>
                    </div>
                    {donationDetails.hasBeneficiary && <>
                        <div className="fieldgroup fieldgroup--checkbox">
                            <input type="radio" id="in-honor-of" value="In honor of" name="beneficiaryType" onChange={(e) => handleDonationDetails(e)} checked={donationDetails.beneficiaryType === "In honor of"} />
                            <label htmlFor="in-honor-of">In honor of</label>
                        </div>
                        <div className="fieldgroup fieldgroup--checkbox">
                            <input type="radio" id="in-memory-of" value="In memory of" name="beneficiaryType" onChange={(e) => handleDonationDetails(e)} checked={donationDetails.beneficiaryType === "In memory of"} />
                            <label htmlFor="in-memory-of">In memory of</label>
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="dedication-first-name">First Name</label>
                            <input id="dedication-first-name" name="dedicationFirstName" type="text" placeholder="First Name" value={donationDetails.dedicationFirstName} onChange={(e) => handleDonationDetails(e)} required />
                            <DonationError donationDetails={donationDetails} fieldName="dedicationFirstName" />
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="dedication-last-name">Last Name</label>
                            <input id="dedication-last-name" name="dedicationLastName" type="text" placeholder="Last Name" value={donationDetails.dedicationLastName} onChange={(e) => handleDonationDetails(e)} required />
                            <DonationError donationDetails={donationDetails} fieldName="dedicationLastName" />
                        </div>
                    </>}
                    <div className="fieldgroup">
                        <label className="sr-only" htmlFor="notes">Notes</label>
                        <textarea id="notes" name="notes" placeholder="Notes (optional)" value={donationDetails.notes} onChange={(e) => handleDonationDetails(e)}/>
                    </div>
                </>}
            </form>
        </>
    );
}

export default DonationOptions;